import { BlocEvent } from 'src/app/shared/bloc/base-bloc';
import { StatisticsFilterForm } from 'src/app/shared/interfaces';

export class StatisticsEvent extends BlocEvent {}

export class StatisticsInitEvent extends BlocEvent {
  constructor(public form: StatisticsFilterForm) {
    super();
  }
}

export class StatisticsPDFGendersEvent extends BlocEvent {
  constructor(public form: StatisticsFilterForm) {
    super();
  }
}

export class StatisticsChartInitEvent extends StatisticsInitEvent {}

export class StatisticsCommentsInitEvent extends StatisticsInitEvent {}
